import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { LanguageContext } from '../LanguageContext';
import config from '../config';
import projets from '../projets';
import ProjetCard from './ProjetCard';

const HomepageContent = () => {
  const { t } = useContext(LanguageContext);

  return (
    <>
      <section className="hero" style={{ backgroundImage: `url(${config.heroImage})` }}>
        <div className="hero__overlay" />
        <div className="hero__content">
          <p className="eyebrow eyebrow--light">{t.hero.eyebrow} · {config.city}</p>
          <h1>{config.name}</h1>
          <p className="hero__tagline">{t.hero.tagline}</p>
          <div className="hero__actions">
            <Link to="/projets" className="btn btn--light">{t.hero.ctaProjects}</Link>
            <Link to="/contact" className="btn btn--ghost">{t.hero.ctaContact}</Link>
          </div>
        </div>
      </section>

      <section className="section container">
        <div className="intro" data-aos="fade-up">
          <h2>{t.intro.title}</h2>
          <p>{t.intro.text}</p>
        </div>
        <div className="grid grid--3 values">
          {t.intro.values.map((v, i) => (
            <div key={v.title} className="value" data-aos="fade-up" data-aos-delay={i * 100}>
              <span className="value__num">0{i + 1}</span>
              <h3>{v.title}</h3>
              <p>{v.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section__head" data-aos="fade-up">
            <p className="eyebrow">{t.projects.featured}</p>
            <h2>{t.projects.title}</h2>
          </div>
          <div className="grid grid--2">
            {projets.map((p, i) => (
              <ProjetCard key={p.slug} projet={p} delay={(i % 2) * 100} />
            ))}
          </div>
        </div>
      </section>

      <section className="section container">
        <div className="section__head" data-aos="fade-up">
          <h2>{t.services.title}</h2>
        </div>
        <div className="grid grid--4">
          {t.services.items.map((s, i) => (
            <div key={s.title} className="service" data-aos="fade-up" data-aos-delay={i * 80}>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="cta">
        <div className="container cta__inner" data-aos="fade-up">
          <h2>{t.cta.title}</h2>
          <p>{t.cta.text}</p>
          <Link to="/contact" className="btn btn--light">{t.cta.button}</Link>
        </div>
      </section>
    </>
  );
};

export default HomepageContent;
